/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Rememberpassword1Inputs */

const zh_auth_rememberpassword1 = /** @type {(inputs: Auth_Rememberpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`记起密码了？`)
};

const en_auth_rememberpassword1 = /** @type {(inputs: Auth_Rememberpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remember your password?`)
};

const es_auth_rememberpassword1 = /** @type {(inputs: Auth_Rememberpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Recuerdas tu contraseña?`)
};

/**
* | output |
* | --- |
* | "Remember your password?" |
*
* @param {Auth_Rememberpassword1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_rememberpassword1 = /** @type {((inputs?: Auth_Rememberpassword1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Rememberpassword1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_rememberpassword1(inputs)
	if (locale === "en") return en_auth_rememberpassword1(inputs)
	return es_auth_rememberpassword1(inputs)
});
export { auth_rememberpassword1 as "auth_rememberPassword" }